var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React from 'react';
import SvgIcon from '@mui/material/SvgIcon';
import MonitorStar from '@mdi/svg/svg/monitor-star.svg';
export var MonitorStarIcon = function (props) { return (React.createElement(SvgIcon, __assign({ component: MonitorStar }, props, { inheritViewBox: true }))); };
